/**
 * Shared copy used across all animated marketing variants. Single source
 * of truth so every ad uses the latest approved verbiage.
 */
export const COPY = {
  brand: "GLPFlo",
  headline1: "Less noise.",
  headline2: "More you.",
  sub: "Normalize the journey.",
  body1: "GLPFlo isn't just a weight-loss injection.",
  body2: "It's a complete lifestyle — tailored to your well-being.",
  body3: "Transparent pricing. Calorie tracking. Workout logging. Follow-ups from a real care team.",
  footer: "No hidden costs. Cancel anytime.",
  url: "glpflo.org",
};
